import { Link } from '@reach/router';
import * as React from 'react';
import styled from 'styled-components';
import { StyledInformationalPage } from '../../../common/static.styles';
import { HeadTitle } from '../../../components/head-title/HeadTitle';
import { DefaultLayout } from '../../../layout/default/DefaultLayout';

// TODO: Add SEO props
const seo = {
  description: '',
};

const StyledFAQPage = styled(StyledInformationalPage)`
  .faq-field:not(:last-of-type) {
    margin-bottom: 3.75em;
  }

  .faq-field-question {
    text-transform: none;
    font-size: 1rem;
    line-height: 1rem;
  }

  .faq-field-answer {
    font-size: 1rem;
  }

  .faq-field-list {
    list-style: disc;
    padding: 0 1rem 0 2rem;
  }

  .faq-field-list-item {
    word-wrap: break-word;
  }
`;

export default () => (
  <DefaultLayout locale='en-US' seo={seo}>
    <HeadTitle title='Help' />
    <StyledFAQPage>
      <div className='content'>
        <section>
          <h1>FAQs</h1>
          <div className='faq-field'>
            <h2 className='faq-field-question'>What is WarnerBros.com?</h2>
            <div className='faq-field-answer'>
              <p>
                WarnerBros.com is your one-stop site for everything Warner Bros. - movies, television, home
                entertainment, games and more!
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>How do I get tickets to attend a live taping of a show ?</h2>
            <div className='faq-field-answer'>
              <p>
                {[
                  'If you are interested in attending a live taping of your favorite show, ',
                  'your best bet would be to visit ',
                ].join('')}
                <a href='http://www.tvtickets.com' target='_blank'>
                  www.tvtickets.com
                </a>{' '}
                where you will find all the information you need. For tickets to the Ellen Degeneres show, visit{' '}
                <a href='http://send.ellentv.com/tickets/' target='_blank'>
                  http://send.ellentv.com/tickets/
                </a>
                .
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>Can I attend a movie premiere?</h2>
            <div className='faq-field-answer'>
              <p>Movie premieres are generally through special invitation only.</p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>How do I purchase tickets for the Warner Bros. Studio Tour?</h2>
            <div className='faq-field-answer'>
              <p>
                You can visit Warner Bros. Studios! To learn about the tour experience, plan your visit and purchase
                tickets, visit the{' '}
                <a href='http://www.wbstudiotour.com' target='_blank'>
                  Warner Bros. Studio Tour Hollywood
                </a>{' '}
                or{' '}
                <a href='http://www.wbstudiotour.co.uk' target='_blank'>
                  Warner Bros. Studio Tour London
                </a>{' '}
                website.
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>How do I sign up for exclusive content from WB Games?</h2>
            <div className='faq-field-answer'>
              <p>
                Join{' '}
                <a href='https://www.wbplay.com' target='_blank'>
                  WBPlay
                </a>{' '}
                to gain access to bonus content, participate in the WB Games community, unlock great interactive content
                and receive WB Games news.
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>How do I get a job with Warner Bros.?</h2>
            <div className='faq-field-answer'>
              <p>
                For a list of available opportunities at our company visit{' '}
                <a href='http://www.warnerbroscareers.com' target='_blank'>
                  Warner Bros. Careers
                </a>
                .
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>
              I have a produced film, television or script idea. How do I submit it to Warner Bros.?
            </h2>
            <div className='faq-field-answer'>
              <p>
                Warner Bros. Entertainment’s policy, as established by its Legal Department, prohibits considering any
                film, television or other story material unless it is submitted by a licensed literary agent who is
                signatory to the Writers Guild Of America. If you are interested in obtaining a list of accredited
                agents, call The Writers Guild at 323-951-4000 or email them through their website at{' '}
                <a href='http://www.wga.org/' target='_blank'>
                  www.wga.org
                </a>
                .
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>Who do I contact for clips &amp; stills licensing inquiries?</h2>
            <div className='faq-field-answer'>
              <p>
                Please review our{' '}
                <Link to='/studio/services/clip-and-still-licensing'>Clip and Still Licensing page</Link> and contact
                our clip and still department at <a href='mailto:clipandstilldept@wbd.com'>clipandstilldept@wbd.com</a>.
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>Who do I contact for product licensing inquiries?</h2>
            <div className='faq-field-answer'>
              <p>
                Please contact our consumer products licensing department at{' '}
                <a href='mailto:WBCPInquiries@wbd.com'>WBCPInquiries@wbd.com</a>.
              </p>
            </div>
          </div>
          <div id='customer-service'>
            <h2 className='faq-field-question'>
              I have read through all the FAQs and I still have a question. What do I do?
            </h2>
            <div className='faq-field-answer'>
              <p>
                If you still have a question after reading through our FAQs, please review our customer support forms
                and contacts:{' '}
              </p>
              <ul className='faq-field-list'>
                <li className='faq-field-list-item'>
                  The CW TV:{' '}
                  <a href='https://support.cwtv.com/hc/en-us' target='_blank'>
                    https://support.cwtv.com/hc/en-us
                  </a>
                </li>
                <li className='faq-field-list-item'>
                  Digital Copy / Movies All Access:{' '}
                  <a href='https://digitalsupport.warnerbros.com/hc/en-us' target='_blank'>
                    https://digitalsupport.warnerbros.com/hc/en-us
                  </a>
                </li>
                <li className='faq-field-list-item'>
                  Games:{' '}
                  <a href='https://support.wbgames.com/' target='_blank'>
                    https://support.wbgames.com/
                  </a>
                </li>
                <li className='faq-field-list-item'>
                  Home Video - DVD / Blu-ray Support:{' '}
                  <a
                    href={
                      'mailto:whv@wbd.com?subject=Home%20Video%20-%20DVD%20%2F%20Blu-ray%20Support' +
                      '&amp;body=Name%3A%20%0AEmail%3A%20%0ADVD%2FBlu-ray%20Disc%3A%20%0AAdditional%20Comments%3A'
                    }
                  >
                    whv@wbd.com
                  </a>
                </li>
                <li className='faq-field-list-item'>
                  Privacy: <a href='mailto:wbdprivacy@wbd.com?subject=Privacy'>wbdprivacy@wbd.com</a>
                </li>
                <li className='faq-field-list-item'>
                  Screeners (aka: eScreeners):{' '}
                  <a href='https://support.wbtvd.com/' target='_blank'>
                    https://support.wbtvd.com/
                  </a>
                </li>
                <li className='faq-field-list-item'>
                  Press Contacts:{' '}
                  <a href='https://www.warnerbros.com/news/press-releases/press-contacts' target='_blank'>
                    https://www.warnerbros.com/news/press-releases/press-contacts
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </div>
    </StyledFAQPage>
  </DefaultLayout>
);
